import { Component, computed, inject, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconCheckRegular } from '@sb/mgc-icons/mgcIcon-check_regular.icon';
import { AccordionModule } from '@sb/ui/accordion';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import { NoticeComponent } from '@sb/ui/notice';
import { clsx } from 'clsx';

import { takeChosenFile } from '../chosen-docx.helper';
import { isCardAnsweredForYou, type BlankCard, type BlankDecision, type Card } from '../detection-derivations.helper';
import { FieldCardComponent, type EntryDecision } from './field-card/field-card.component';
import { MissingFieldPanelComponent } from './missing-field-panel/missing-field-panel.component';

const entryCount = (cards: BlankCard[]) => cards.reduce((count, card) => count + card.entries.length, 0);

/** Step 2: one card per detected field, next to the document. */
@Component({
  selector: 'check-fields-step',
  templateUrl: './check-fields-step.component.html',
  imports: [
    AccordionModule,
    FieldCardComponent,
    IconComponent,
    MissingFieldPanelComponent,
    NoticeComponent,
    TranslatePipe,
  ],
  host: { '[class]': 'hostClasses' },
})
export class CheckFieldsStepComponent {
  hostClasses = clsx('flex flex-col gap-lg');

  cards = input.required<Card[]>();
  decisions = input.required<ReadonlyMap<string, BlankDecision>>();

  decided = output<EntryDecision[]>();
  upload = output<File>();

  rejectedFile = signal(false);

  blankCards = computed(() => this.cards().filter((card): card is BlankCard => card.kind === 'blank'));
  openCards = computed(() => this.blankCards().filter((card) => !isCardAnsweredForYou(card)));
  answeredCards = computed(() => this.blankCards().filter(isCardAnsweredForYou));
  toDecideCount = computed(() => entryCount(this.openCards()));
  matchedCount = computed(() => entryCount(this.answeredCards()));

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconCheckRegular]);
  }

  chooseFile(fileInput: HTMLInputElement): void {
    const chosen = takeChosenFile(fileInput);

    if (!chosen) {
      return;
    }

    this.rejectedFile.set(!chosen.isDocx);

    if (chosen.isDocx) {
      this.upload.emit(chosen.file);
    }
  }
}
